import React, { useEffect, useRef, useState } from "react";

import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { MdMoveUp } from "react-icons/md";

import "./asociadosTable.css";
import styles from "./../tooltip.module.css";

//import * as SVGImages from "../../svg";
// Clean, short, and zero dependencies!
import * as SVGImages from "components/proto/svg";
import { buildName, Singleton } from "helper/tools";

import SkeletonTable from "components/proto/components/Skeleton/SkeletonTable";
import { handleNivel, handleStatus } from "../../helperFunctions/helpers";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import { useAuthStore, useStore } from "../../../../store/store";
import ConfigForaneo from "../Ventas/ConfigForaneo";
import ActualizarCreditoDispuesto from "./ActualizarCreditoDispuesto";
import BadgeStatus from "./BadgeStatus";

/**
 *
 * @param {*} param0
 * @returns
 */

export default function AsociadosTable({
  openItem,
  openChangeCreditLimit,
  openChangeLevel,
  openCongelarDescongelar,
  handleSortChange,
  reloadAsociados,
  isLoading = false,
}) {
  const theadRef = useRef();
  const createProductoRef = useRef();

  const isAdmin = useAuthStore((state) => state.isAdmin);

  const [modalData, setModalData] = useState(null);
  const [permissions, setPermissions] = useState({
    canSetLimiteDeCredito: true,
    canSetNivel: true,
    canSetCongelar: true,
  });

  const store = useStore((state) => state);

  //const filtrosRef = useRef([]);

  const CongelarOptions = {
    CONGELAR: {
      bgColor: "#0dcaf0",
      img: {
        src: SVGImages.SNOWFLAKE,
        alt: "Solicitar Congelar",
      },
    },
    DESCONGELAR: {
      bgColor: "#ffc107",
      img: {
        src: SVGImages.SUN,
        alt: "Solcitar Descongelar",
      },
    },
  };

  useEffect(() => {
    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  function configAddress(item, index) {
    let newItem = {
      id: 0,
      ordenVentaId: item.id,
    };
    if (item.entregasForaneas?.length > 0) {
      newItem = item.entregasForaneas[0];
    }

    newItem.ordenVentaId = item.id;

    loadItem(newItem);
  }

  function loadItem(item) {
    setModalData(item);

    createProductoRef.current.toggleModal();
  }

  return (
    <>
      <table className="table table-borderless datable sortable table-hover">
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              rowSpan={2}
              scope="col"
              data-column="id"
              style={{ width: "50px", verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>
            <th
              rowSpan={2}
              scope="col"
              data-column="nombre"
              style={{ verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Nombre
            </th>
            {/*  TODO: hasta que se agreguen otras sucursales *1 <th
              scope="col"
              data-column="responsable"
              onClick={(event) => handleSort(event)}
            >
              Responsable
            </th>*/}

            <th
              colSpan={4}
              scope="col"
              className="no-sort"
              style={{ borderBottom: "solid" }}
            >
              Credito
            </th>

            <th
              rowSpan={2}
              scope="col"
              data-column="nivelId"
              style={{
                width: "50px",
                verticalAlign: "middle",
                textAlign: "center",
              }}
              onClick={(event) => handleSort(event)}
            >
              Nivel
            </th>
            <th
              rowSpan={2}
              scope="col"
              data-column="activo"
              style={{ width: "50px", verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Estatus
            </th>
            <th
              rowSpan={2}
              scope="col"
              className="no-sort"
              style={{ verticalAlign: "middle" }}
            >
              Acciones
            </th>
          </tr>
          <tr>
            <th
              scope="col"
              data-column="limiteCredito"
              style={{ width: "140px", verticalAlign: "middle" }}
              onClick={(event) => handleSort(event)}
            >
              Limite
            </th>
            <th
              scope="col"
              data-column="credito"
              onClick={(event) => handleSort(event)}
            >
              Dispuesto
            </th>
            <th
              scope="col"
              data-column="CredDisPor"
              onClick={(event) => handleSort(event)}
            >
              % Dispuesto
            </th>
            <th
              scope="col"
              data-column="CreditoDisponible"
              onClick={(event) => handleSort(event)}
            >
              Disponible
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={8} rowCount={6} />}

          {!isLoading &&
            store.asociados != null &&
            store.asociados?.length > 0 &&
            store.asociados?.map((item, index) => {
              const nombre = buildName(item, true);

              const creditoDispuesto = Singleton.getInstance().format(
                item.credito,
              );
              const limiteCredito = Singleton.getInstance().format(
                item.limiteCredito,
              );
              const creditoDispuestoPer = item.credDisPor;
              const creditoDisponible = Singleton.getInstance().format(
                item.creditoDisponible,
              );

              const congeladoSetup = item.congelado
                ? CongelarOptions.DESCONGELAR
                : CongelarOptions.CONGELAR;

              const mode = `Solicitar Cambio a ${
                item.congelado ? "Descongelado" : "Congelado"
              }`;

              return (
                <tr key={item.id}>
                  <th
                    scope="row"
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.numAsociado ?? ""}
                    </a>
                  </th>
                  <td>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {nombre}
                    </a>
                  </td>
                  {/*TODO: hasta que se agreguen otras sucursales *1 <td>{item.usuarioUsername}</td>*/}
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {limiteCredito}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          columnGap: "5px",
                          flexDirection: "row",
                          justifyItems: "center",
                        }}
                      >
                        <div
                          style={{
                            justifyItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <span
                            className="badge bg-warning text-dark"
                            style={{ minWidth: "65px", fontSize: "13px" }}
                          >
                            {creditoDispuesto}
                          </span>
                        </div>
                        {isAdmin && (
                          <>
                            <ActualizarCreditoDispuesto
                              item={item}
                              reload={reloadAsociados}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {creditoDispuestoPer}
                  </td>

                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {creditoDisponible}
                  </td>

                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <span className={`badge ${handleNivel(item.nivel?.id)}`}>
                      {item.nivel?.nombre}
                    </span>
                  </td>
                  <BadgeStatus item={item} />
                  <td>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {!permissions.canSetLimiteDeCredito &&
                        !permissions.canSetNivel && <span>-</span>}
                      {permissions.canSetLimiteDeCredito && (
                        <button
                          className={`btn btn-info ${styles.tooltip}`}
                          style={{
                            marginLeft: "0px",
                            backgroundColor: "#81C784",
                          }}
                          onClick={(event) =>
                            openChangeCreditLimit(event, item)
                          }
                        >
                          <div>
                            <span className={`${styles.tooltiptext}`}>
                              Solicitar Cambio Limite de Credito
                            </span>
                            <FaMoneyBillTrendUp />
                          </div>
                        </button>
                      )}
                      {permissions.canSetNivel && (
                        <button
                          className={`btn btn-warning ${styles.tooltip}`}
                          style={{
                            backgroundColor: "#B39DDB",
                          }}
                          onClick={(event) => openChangeLevel(event, item)}
                        >
                          <div>
                            <span className={`${styles.tooltiptext}`}>
                              Solicitar Cambio de Nivel
                            </span>
                            <MdMoveUp />
                          </div>
                        </button>
                      )}
                      {permissions.canSetCongelar && (
                        <button
                          className={`btn btn-primary ${styles.tooltip}`}
                          style={{
                            backgroundColor: `${congeladoSetup.bgColor}`,
                          }}
                          onClick={(event) =>
                            openCongelarDescongelar(event, item)
                          }
                        >
                          <div>
                            <span className={`${styles.tooltiptext}`}>
                              {mode}
                            </span>
                            <img
                              alt=""
                              {...congeladoSetup.img}
                              style={{ width: "16px", height: "16px" }}
                            />
                          </div>
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      <ConfigForaneo
        ref={createProductoRef}
        item={modalData}
        reloadAsociados={reloadAsociados}
      />
    </>
  );
}
